ACC.userlocation = {

	bindAll: function ()
	{
		ACC.userlocation.bindUserLocationSearchButtonClick();
		ACC.userlocation.bindUserLocationEnterPress();
		ACC.userlocation.bindAutoLocationSearchButtonClick();
		ACC.userlocation.bindAutoLocationDirectionButtonClick();
	},

	bindUserLocationEnterPress: function ()
	{
		$('#user_location_query').keypress(function (e)
		{
			var code = null;
			code = (e.keyCode ? e.keyCode : e.which);
			if (code == 13)
			{
				$.ajax({
					url: searchUserLocationUrl,
					type: 'GET',
					data: {q: $('#user_location_query').attr("value")}
                }).done(function (data) {
						location.reload();
				});
				return false;
			}
			;
		});
	},

	bindUserLocationSearchButtonClick: function ()
	{
		$('#user_location_query_button').click(function (e)
		{
			$.ajax({
				url: searchUserLocationUrl,
				type: 'GET',
				data: {q: $('#user_location_query').attr("value")}
            }).done(function (data) {
					location.reload();
			});
			return false;
		});
	},

	bindAutoLocationSearchButtonClick: function ()
	{
		$(document).on("click", "#findStoresNearMeAjax", function (e)
		{
			e.preventDefault();
      try {
        var gps = navigator.geolocation;
        gps.getCurrentPosition(ACC.userlocation.positionSuccessStoresNearMeAjaxGglAPi, function (error) {
          $('#geoLocationError').show();
          console.log("An error occurred... The error code and message are: " + error.code + "/" + error.message);
        });
      }
      catch (error) {
        console.log("An error occurred... ");
      }
    });

    $(document).on("click", "#findStoresNearMe", function (e) {
      e.preventDefault();
      try {
        var gps = navigator.geolocation;
        gps.getCurrentPosition(ACC.userlocation.positionSuccessStoresNearMeGglApi, function (error) {
          $('#geoLocationError').show();
          console.log("An error occurred... The error code and message are: " + error.code + "/" + error.message);
        });
      }
      catch (error) {
        console.log("An error occurred... ");
      }
				});
	},

	positionSuccessStoresNearMeAjaxGglApi: function (position)
	{
		if (typeof autoUserLocationUrl !== 'undefined')
		{
			$.ajax({
				url: autoUserLocationUrl,
				type: 'POST',
				data: {latitude: position.coords.latitude, longitude: position.coords.longitude}
            }).done(function (data) {
					location.reload();
			});
		}

		return false;
	},


    bindAutoLocationDirectionButtonClick: function () {
        $(document).on("click", "#btn-direction", function (e) {
            e.preventDefault();
            var position;
            var repairlongitude = $(this).data("repairlongitude");
            var repairlatitude = $(this).data("repairlatitude");

            var $searchAddressForm = $('#repairs-search'),
                address = $searchAddressForm.find('#search-filter_street_repairs').val(),
                postalCode = $searchAddressForm.find('#search-filter_postalCode_repairs').val(),
                city = $searchAddressForm.find('#search-filter_city_repairs').val(),
                fullSearchingAddress = address +' '+ postalCode +' '+ city;


            jQuery.post( "https://www.googleapis.com/geolocation/v1/geolocate?key="+getGglAPIKey(),function () {
                ACC.userlocation.directionToRepairCenterGglApi(repairlongitude, repairlatitude, fullSearchingAddress)})
                .fail(function(err) {
                    console.log("API Geolocation error! \n\n"+err);
                });

        });
    },

    directionToRepairCenterGglApi: function (repairlongitude, repairlatitude, fullSearchingAddress) {
        var googleMapURI = 'https://www.google.fr/maps';

        if(fullSearchingAddress) {
            var url = googleMapURI + '/dir/' + fullSearchingAddress + '/' + repairlatitude + ',' + repairlongitude;
            window.open(
                url,
                '_blank' // <- This is what makes it open in a new window.
            );
        } else {
            var url = googleMapURI + '?q=' + repairlatitude + ',' + repairlongitude + '&amp;t=h&amp;z=16';
            window.open(
                url,
                '_blank' // <- This is what makes it open in a new window.
            );
        }
        return false;
    },

	calculateAndDisplayRoute: function (directionsService, directionsDisplay,start,end) {
		  directionsService.route({
			    origin:  start,
			    destination: end,
			    travelMode: google.maps.TravelMode.DRIVING
			  }, function(response, status) {
			    if (status === google.maps.DirectionsStatus.OK) {
			      directionsDisplay.setDirections(response);
			    } else {
			      console.log('Directions request failed due to ' + status);
			    }
			  });

	},

	positionSuccessStoresNearMeGglApi: function (position)
	{
		$("#latitude").val(position.coords.latitude);
		$("#longitude").val(position.coords.longitude);
        submitStoreLocatorFormWithAjax($("#nearMeStorefinderForm"), 'GET');
		return false;
	}

};

ACC.addressgeocode = {

    bindAll: function () {
        ACC.addressgeocode.bindAddressGeocodeSubmit();
    },

    bindAddressGeocodeSubmit: function () {
      $('#search-filter_city_repairs').keypress(function (e) {
        if (e.which == 13) {//Enter key pressed
          $('#repairs-search form[name^="search_form"] button[type="submit"],#store-search form[name^="search_form"] button[type="submit"]').click();
        }
      });
      $(document).on("click", '#store-search form[name^="search_form"] button[type="submit"]', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($("#search-filter_city_store").val() == "") {
          $('#cityError').show();
        } else {
          $('#cityError').hide();
          ACC.addressgeocode.geocodeAddress(true);
        }
      });

      $(document).on("click", '#repairs-search form[name^="search_form"] button[type="submit"]', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var error = false;
        if ($("#country").val() == null) {
          var error = true;
          $('#countryError').show();
        }
        else {
          $('#countryError').hide();
        }
        if ($("#search-filter_city_repairs").val() == "") {
          var error = true;
          $('#cityError').show();
        }
        else {
          $('#cityError').hide();
        }

        if (error == false) {
          $('#q').val($("#search-filter_city_repairs").val());
          ACC.addressgeocode.geocodeAddress(true);
        }
      });

      $(document).on("click", '.crumbs a', function (e) {
          e.preventDefault();
          var $target =  $(e.currentTarget);
          var filterToRemove = $target.data('facet-code');
          //Stop event from triggering twice.
          e.stopImmediatePropagation();
          var $repairStoreFilter = $target.closest('#repair-store-filter'), $searchListPageFilters;
          if (!!$repairStoreFilter.length) {
              $repairStoreFilter
                  .find('.filters-container input[type=checkbox][data-facet-code="' + filterToRemove + '"]:not([readonly])')
                  .prop('checked', false)
                  .change();
          } else if (!!($searchListPageFilters = $target.closest('#search-list-page--filters')).length) {
              if ($target.is('.filter-init.reset')) {
                  window.location.href = $target.attr('href');
              } else {
                  $searchListPageFilters
                      .find('.accordion-group input[type=checkbox][data-facet-code="' + filterToRemove + '"]:not([readonly])')
                      .prop('checked', false)
                      .change();
              }
          }
      });

      $(document).on("click", '.crumbs .filter-init', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $(".filters-container input[type=checkbox][data-facet-code]:not([readonly])").prop("checked", false);
        $("input[name=features]").val($(e.target).val());

        ACC.addressgeocode.geocodeAddress(true);
        $observables.storeLocatorObservables.next('skip');
      });

      $(document).on("change", '.filters-container input:not([readonly])', function (e) {

        //Stop event from triggering twice.
        e.stopImmediatePropagation();

        $("input[name=features]").val($(e.target).val());
        ACC.addressgeocode.geocodeAddress(true);
        $observables.storeLocatorObservables.next('skip');
      });

      $('#repairs-search form[name^="search_form"] input[name="q"],#store-search form[name^="search_form"] input[name="q"]').keypress(function (e) {
        var code = null;
        code = (e.keyCode ? e.keyCode : e.which);
        if (code == 13) {
          e.preventDefault();
          ACC.addressgeocode.geocodeAddress(true);
        }
      });

      window.$observables.storeLocatorObservables = new Observable();

      $observables.storeLocatorObservables.subscribe(function (value) {
        smoothScrollingTo(!!$("#StoreLocator").find('.map-container').length ? '#StoreLocator .map-container' : '#StoreLocator .pos-features-not-found', 60)
      })
    },

    geocodeAddress: function (isLocationSearch){

        var featuresFilter = ACC.addressgeocode.getFeaturesFilter();
        var searchAddress = ACC.addressgeocode.getLocationSearch();
        //include the postal code in api request
        var postalCode = $("#search-filter_postalCode_repairs").val();
        searchAddress = postalCode !== "" ? postalCode +"+" + searchAddress : searchAddress;

        if ((typeof searchAddress!= 'undefined') &&!!searchAddress.trim()) {

            var query = "https://maps.googleapis.com/maps/api/geocode/json?address=" + searchAddress + "+"
                + ACC.addressgeocode.getCountryIsoCode() + "&components=country:" + ACC.addressgeocode.getCountryIsoCode()
                + "&key=" + getGglAPIKey();
            console.log(query + '\n\n');
            jQuery.post(query, ACC.addressgeocode.positionSuccessStoresNearLocationGglApi)
                .fail(function (err) {
                    console.log("API Geocoding error! \n\n" + err); //Usually means that a new key needs to be generated.
                });

        } else if (!!featuresFilter.trim()) {

            if($("#longitude").val() && $("#latitude").val() && !isLocationSearch) {
                submitStoreLocatorFormWithAjax($("#nearMeStorefinderForm"), 'GET');
            } else if (isLocationSearch) {
                var repairsSearchWithFeaturesOnly = ACC.addressgeocode.createRepairStoreForm(featuresFilter.trim());
                repairsSearchWithFeaturesOnly.appendTo(".repairs-filter");
                submitStoreLocatorFormWithAjax(repairsSearchWithFeaturesOnly, 'GET');
            }

        } else {

            if(!$('#repair-store-filter').length){

                window.location = window.location.pathname;

            } else {

                if($("#longitude").val() && $("#latitude").val() && !isLocationSearch) {
                    submitStoreLocatorFormWithAjax($("#nearMeStorefinderForm"), 'GET');
                } else if (isLocationSearch) {
                    var repairsSearchWithFeaturesOnly = ACC.addressgeocode.createRepairStoreForm('');
                    repairsSearchWithFeaturesOnly.appendTo(".repairs-filter");
                    submitStoreLocatorFormWithAjax(repairsSearchWithFeaturesOnly, 'GET');
                }

            }

        }

    },

    getCountryIsoCode: function(){
        return $('form[name^="search_form"] input[name="country"],form[name^="search_form"] select[name="country"]').val();
    },

    getLocationSearch: function(){
        return $('form[name^="search_form"] input[name="q"]').val();
    },

    getFeaturesFilter: function(){
        return $('#repairs-search input#features[name="features"]').val();
    },

    setFeaturesFilter: function(){
        if($("#features").length > 0){
            $("[name='features']").val(getInputValuesAsJoinedArray($('[name="feature"]:checked')));
        }
    },

    createRepairStoreForm : function(features){
        return $('<form>', {
            'id': 'repairs_search_with_features_only',
            'action': '',
        }).append($('<input>', {
            'name': 'features',
            'value': features,
            'type': 'hidden'
        }));
    },

    positionSuccessStoresNearLocationGglApi: function (position) {
        if(position.status == google.maps.GeocoderStatus.OK){
            $("#geocodedlatitude").val(position.results[0].geometry.location.lat);
            $("#geocodedlongitude").val(position.results[0].geometry.location.lng);
            if($("#repairs-search form[name^='search_form']").length) {
                submitStoreLocatorFormWithAjax($("#repairs-search form[name^='search_form']"), 'GET');
            } else {
                $("#store-search form[name^='search_form']").submit();
            }
        } else{
            console.log("Geocoding error status: " + position.status);
        }
        return false;
    }

};

$(document).ready(function () {
    ACC.userlocation.bindAll();
    ACC.addressgeocode.bindAll();
});

function getGglAPIKey(){
	var key = null;
    jQuery.ajax({
        type: "GET",
        url:"/buyonline/gglApiKey/ajax",
        async:false
    }).done(function (data) {

        	key=data;
    }).fail(function(xhr, status, error) {
        	console.log("Cannot get key api !");
    });
    return key;
}

function getInputValuesAsJoinedArray(element){
    var values = element.map(function(_, el) {
        return $(el).val();
    }).get().join(",");
    return values;
}
